/**
 * PlanningEventCategoryEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { PlanningEventCategoryEntity } from "../PlanningEventCategoryEntity";
declare global {
    interface EntityTypeMap {
        PlanningEventCategory: PlanningEventCategoryEntity;
    }
}
export abstract class PlanningEventCategoryGeneratedEntity extends BaseEntity {
    public abstract planningEventCategoryId: string;
    public abstract templateId: string | null;
    public abstract text: string;
    public abstract project: ProjectEntity;
    public abstract readonly planningEvents: ReadonlyArray<PlanningEventEntity>;
}
